<mat-list role="list">
  <ng-container *ngFor="let subItem of subMenuItems">
    <mat-list-item
      *ngIf="!subItem.isVisible$ || (subItem.isVisible$ | async)"
      routerLinkActive="selected"
      class="sidebar-list-item slide-in-nav-item"
      role="listitem"
      ix-auto
      ix-auto-type="option"
      [ix-auto-identifier]="subItem.name"
      (click)="toggleMenu.emit()"
    >
      <a class="slidein-nav-link" [routerLink]="['/', menuName, subItem.state]">
        {{ subItem.name | translate }}
      </a>
    </mat-list-item>
  </ng-container>
</mat-list>
